<template>
        <div class="list-content">
            <div class="filter-select-div el-div-long mb11">
                <span class="filter-select-span mr20">언어</span>
                <el-select v-model="langOption" class="select mr5" @change="setLanguageFilter(langOption)">
                    <el-option :value="''" :label="'전체'"></el-option>
                    <el-option :value="language.c_idx" :label="language.c_lang_ko" v-for="language in languageList"
                               :key="language.c_idx"></el-option>
                </el-select>
            </div>
            <div class="table_wrap">
                <el-table class="list-table" header-cell-class-name="list-header" :data="languageListOption"
                          style="width: 100%;" height="695" empty-text="데이터가 없습니다.">
                    <el-table-column
                        class="table_no"
                        type="index"
                        label="No"
                        min-width="70"
                        class-name="num text-center">
                    </el-table-column>
                    <el-table-column label="종류" prop="c_lang_ko" class-name="text-center"></el-table-column>
                    <el-table-column
                        label="옵션" width="85" class-name="text-center">
                        <template slot-scope="scope">
                            <div class="row-info">
                                <el-button
                                    @click="movePage(scope.row.c_idx)">
                                    상세
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
</template>

<script>
import languageList from "@/mixins/languageList";

export default {
    name: "TermsListComponent",
    mixins: [languageList],
    components: {},
    inject: ['changeLoading'],
    provide() {
        return {}
    },
    props: {
        termsType: {},
    },
    data() {
        return {
            languageList: [],
            langOption: '',
            languageListOption: []
        }
    },
    created() {
        this.getLanguage()

    },
    mounted() {

    },
    beforeDestroy() {

    },
    destroyed() {
    },
    computed: {},
    methods: {
        movePage(type) {
            this.$router.push(`/jst/service/terms/${this.termsType}/${type}`);
        },
        getLanguage() {
            this.$api.$config.getCountry({}).then(res => res.Data.Result).then(res => {
                if (res.Info.type !== 1) {

                } else {

                    this.languageList = res.List
                    this.languageListOption = this.languageList

                }
            })
        },
        setData(key, value) {
            this[key] = value;
        },

        setLanguageFilter(idx) {
            if (idx === '') {
                this.languageListOption = this.languageList
            } else this.languageListOption = this.languageList.filter(v => v.c_idx === idx)
        }


    },
    watch: {},
}
</script>

<style scoped>

</style>